import React from "react";
import styled from "styled-components";
import { Row, Container, Col, Image } from "react-bootstrap";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import photo_resume from "../img/photo_resume.webp";

export default () => {
  return (
    <Styles>
      <Container className="resume-container">
        <Row className="name">
          <Col
            xs={{ size: 12, order: "last" }}
            md={{ size: 12, order: "first" }}
            className="name-container"
          >
            <h1>Ivy Pratiwi</h1>
            <h4>Data Scientist | Front End Developer</h4>
            <a
              href="https://www.linkedin.com/in/ivypratiwi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin color=" #0676b3" size="1.5em" />
            </a>{" "}
            <a
              href="https://github.com/ivypratiwi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub size="1.5em" color="black" />
            </a>
          </Col>
          <Col xs={12} md={6} className="photo-container">
            <Image src={photo_resume} type="image/webp" className="photo" />
          </Col>
        </Row>
        <Row className="col-profile">
          <Col md={10}>
            <h3>Key Profile</h3>
            <hr className="word-underline"></hr>
            <ul>
              <li>
                An optimistic, result-driven, and hard-working individual with
                ready to learn mindset always excel in developing and
                maintaining good relationship with people from various
                backgrounds.
              </li>
              <li>
                A proven track record as high achiever: QUT Dean's List Award
                recipient and highest performer for bachelor degree programme in
                2015.
              </li>
              <li>
                Front-end development skills: ReactJS, React Native, NodeJS,
                Express, Cloud Computing (AWS), HTML, CSS, Bootstrap,
                JavaScript, Python Flask, Python Jinja, and MySQL.{" "}
              </li>
              <li>
                Data science skills: Data Preprocessing, Machine Learning,
                Classification (Decision Tree, Logistic Regression, Neural
                Network, SVM), Clustering and Association Mining (K-Means,
                DBSCAN, Apriori), Text and Topic Analysis (NLP, NLTK, TF-IDF,
                LDA, NMF).
              </li>
            </ul>
            <hr className="border-underline"></hr>
          </Col>
        </Row>
        <Row>
          <Col md={10} sm={12} className="col-experience">
            <h3>Experience</h3>
            <hr className="word-underline"></hr>
            {/* BHP */}
            <h5 className="heading">Data Analyst</h5>
            <h6>BHP (Australia) | Aug 2021 - Present</h6>
            {/* Tiny*/}
            <h5 className="heading">QA Engineer Intern</h5>
            <h6>Tiny Technologies (Australia) | Feb 2021 - Jul 2021</h6>
            <ul>
              <li>Undertook software testing and troubleshooting.</li>
              <li>
                Designed and implemented test cases for new and existing
                features.
              </li>
              <li>Executed the test process and consolidating test results.</li>
              <li>Assisted in test automation.</li>
              <li>
                Technology used: Jira, Testrail, Javascript (NodeJS), Docker,
                HTML.
              </li>
            </ul>
            {/* Colab*/}
            <h5 className="heading">Rapid Design Sprint Collaborator</h5>
            <h6>
              Queensland University of Technology (Australia) | Oct 2019 - Dec
              2019
            </h6>
            <ul>
              <li>
                Shortlisted to join QUT Colab and worked in a team to solve a
                learning and teaching problem in QUT. Our solution was placed in
                the third place and we were hired to improve the minimum viable
                product (MVP).{" "}
              </li>
              <li>
                Created an online platform, named as Interact, to establish a
                supportive environment for international students in QUT.
              </li>
              <li>Technology used: HTML, CSS, and JavaScript.</li>
            </ul>
            {/* QI */}
            <h5 className="heading">Accounts Executive</h5>
            <h6>
              Quantum Inventions Pte Ltd (Singapore), Subsidiary of Continental
              AG Corporation | Feb 2016 – Dec 2017{" "}
            </h6>
            <ul>
              <li>
                Managed full set of accounts (Balance Sheet and P&L) for parent
                company in Singapore and its subsidiaries in South East Asia for
                month and year end closing.
              </li>
              <li>
                Prepared, maintained and managed company’s account readily for
                the quarterly GST submission, annual budget, and periodic
                forecast of cash flow.
              </li>
              <li>
                Maintained and monitored fixed asset register, inventory and
                other accounting function within the company.
              </li>
              <li>
                Prepared Projects related, Inter-company billing and
                reconciliation.
              </li>
            </ul>
            <hr className="border-underline"></hr>
          </Col>
        </Row>
        <Row>
          <Col md={10} sm={12} className="col-education">
            <h3>Education</h3>
            <hr className="word-underline"></hr>
            {/* QUT*/}
            <h5 className="heading">
              Master of Information Technology (Data Science Major)
            </h5>
            <h6>Queensland University of Technology | Jul 2019 – Jul 2021</h6>
            <ul>
              <li>
                International Merit Scholarship recipient from QUT Science and
                Engineering Faculty.
              </li>
              <li>Dean's List Award recipient for excellent performance.</li>
              <li>
                Completed a web development project using AWS Auto Scaling, S3
                bucket and ElastiCache.{" "}
              </li>
              <li>
                Undertook an industry project in Data Science with DNRME
                utilising Natural Language Processing (NLP) and clustering
                algorithms.
              </li>
              <li>
                Completed a project with EzyQuip Hire to develop a predictive
                model and descriptive analysis for their maintenance and cost
                strategy.
              </li>
              <li>
                Technology learnt: reactJS, react native, nodeJS, express, cloud
                computing, python flask, jinja, HTML, CSS, Data Science and
                Machine Learning algorithms (classification, clustering and text
                mining).{" "}
              </li>
              <li>GPA: 7.0 out of 7.0</li>
            </ul>
            {/* ZJU */}
            <h5 className="heading">Chinese Language and Culture</h5>
            <h6>Zhejiang University | Mar 2018 – Jan 2019</h6>
            <ul>
              <li>
                Studied Chinese language and culture, more importantly
                understanding the history and impact of financial planning and
                decisions made by Chinese government.
              </li>
              <li>
                Scholarship recipient for the Chinese Language Study for an
                outstanding performance in the first semester.
              </li>
            </ul>
            {/* UCD */}
            <h5 className="heading">
              Bachelor of Science (Honours) in Finance{" "}
            </h5>
            <h6>University College of Dublin | May 2014 – Mar 2016 </h6>
            <ul>
              <li>
                Graduated with First Class Honours and the highest GPA of the
                cohort.
              </li>
              <li>
                Programme Achievement Award Recipient for outstanding academic
                performance.
              </li>
            </ul>
            <hr clasName="border-underline"></hr>
          </Col>
        </Row>
        <Row>
          <Col md={10} sm={12} className="col-award">
            <h3>Award</h3>
            <hr className="word-underline"></hr>
            {/* QUT*/}
            <h5 className="heading">International Merit Scholarship</h5>
            <h6>Queensland University of Technology | Jul 2019 – Jul 2021</h6>
            <ul>
              <li>
                International Merit Scholarship recipient from QUT Science and
                Engineering Faculty.
              </li>
            </ul>
            <h5 className="heading">Dean's List Award</h5>
            <h6>Queensland University of Technology | Feb 2021</h6>
            <ul>
              <li>
                Awarded a place on the Dean's List for Excellent Academic
                Performance for all semesters.
              </li>
            </ul>
            {/* UCD */}
            <h5 className="heading">Program Achievement Award</h5>
            <h6>University College Dublin | May 2016</h6>
            <ul>
              <li>
                Awarded with Program Achievement Award for graduating with the
                highest Grade Point Average (GPA) in cohort.
              </li>
            </ul>
            {/* CISI */}
            <h5 className="heading">Annual CISI National Award (Singapore)</h5>
            <h6>
              Chartered Institute for Securities and Invesment | Jan 2014{" "}
            </h6>
            <ul>
              <li>
                Awarded Annual CISI National Award (Singapore) for top
                performance on International Introduction to Securities and
                Investment examination result in 2014. The examination result is
                one of the highest in Singapore during 2013/2014 awards
                selection period.
              </li>
            </ul>
            <hr clasName="border-underline"></hr>
          </Col>
        </Row>
        <Row>
          <Col md={10} sm={12} className="col-certificate">
            <h3>Certificates and Online Courses</h3>
            <hr className="word-underline"></hr>
            {/* Azure*/}
            <h5 className="heading">
              Microsoft Certified: Data Analyst Associate
            </h5>
            <h6>Microsoft | Nov 2021</h6>
            {/* Azure*/}
            <h5 className="heading">
              Microsoft Certified: AI-900 AI Fundamentals
            </h5>
            <h6>Microsoft | Jul 2021</h6>
            <h5 className="heading">
              Microsoft Certified: AZ-900 Azure Fundamentals
            </h5>
            <h6>Microsoft | Apr 2021</h6>
            {/* GCP*/}
            <h5 className="heading">
              Google Cloud Platform Fundamental: Core Infrastructure
            </h5>
            <h6>Coursera | Jul 2020</h6>
            {/* Axure */}
            <h5 className="heading">Advanced Scripting with Axure RP</h5>
            <h6>LinkedIn Learning | Mar 2020</h6>
            {/* UCD */}
            <h5 className="heading">Axure RP for UX Design</h5>
            <h6>LinkedIn Learning | Nov 2019 </h6>
            {/* CISI */}
            <h5 className="heading">
              International Operations Certificate (Singapore){" "}
            </h5>
            <h6>
              Chartered Institute for Securities and Investment (CISI) | May
              2014{" "}
            </h6>
            {/* CISI */}
            <h5 className="heading">
              International Certificate in Investment Management (Singapore)
            </h5>
            <h6>
              Chartered Institute for Securities and Investment (CISI) | May
              2014{" "}
            </h6>
            <hr clasName="border-underline"></hr>
          </Col>
        </Row>
        <Row>
          <Col md={10} sm={12} className="col-activities">
            <h3>Activities</h3>
            <hr className="word-underline"></hr>
            <ul>
              <li className="heading">
                QUT Connector | QUT College of Excellence
              </li>
              <li className="heading">World Science Festival Volunteer</li>
              <li className="heading">Something Digital Festival Volunteer</li>
              <li className="heading">YOW Developer Conference Volunteer</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Styles>
  );
};

const Styles = styled.div`
  padding-top: 3%;
  margin-bottom: -10%;

  .col-profile {
    margin-top: 5%;
  }
  .resume-container {
    padding: 8% 8% 8% 8%;
    text-align: justify;
  }
  .photo-container {
    text-align: center;
  }
  .photo {
    width: 30%;
    border-radius: 50%;
  }
  .heading {
    margin-top: 3%;
    text-align: left;
  }

  .border-underline {
    margin-top: 40px;
    height: 1px;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75),
      rgba(255, 255, 255, 0)
    );
  }

  .word-underline {
    width: 8%;
    margin-left: 2px;
    margin-top: -3px;
    border: 0.3px solid #45908b;
  }

  @media (min-width: 2200px) {
    .resume-container {
      padding: 8% 0% 8% 0%;
    }
    h5 {
      font-size: 140%;
    }
    h6 {
      font-size: 115%;
    }
    li {
      font-size: 120%;
    }
  }

  @media (max-width: 1024px) {
    padding-top: 10%;
    h4 {
      font-size: 120%;
    }
  }

  @media (max-width: 768px) {
    padding-top: 10%;
    h1 {
      font-size: 200%;
    }
    h4 {
      font-size: 100%;
    }
    .col-certificate {
      text-align: left;
    }
  }

  @media (max-width: 736px) {
    padding-top: 20%;
    margin-bottom: -5%;
    .name {
      text-align: center;
    }
    h1 {
      font-size: 200%;
    }
    h4 {
      font-size: 100%;
    }
    h3 {
      font-size: 140%;
    }
    h5 {
      font-size: 110%;
    }
    p,
    h6,
    li {
      font-size: 85%;
    }
    .name-container {
      text-align: center;
    }
    .word-underline {
      width: 15%;
    }
  }
`;
